import request from '../utils/http'
import storage from '../utils/storage'
const appid = storage.get('USERINFO') ? storage.get('USERINFO').appid : 2000  // 不同小程序对接同一后台
// appid：3-维应企微SPR开发版 | 2003-维应企微SPR
// getQyLogin

// 知识付费列表 498
export function getKonwledgeList(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_paypage',
            ...data
        }  //接口参数
    })
}

// 知识付费-新增 499
export function addKonwledge(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_payadd',
            appid,
            ...data
        }  //接口参数
    })
}

// 知识付费-修改 500
export function editKonwledge(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_payedit',
            appid,
            ...data
        }  //接口参数
    })
}

// 知识付费-新增 501
export function getKonwledgeDetail(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_payview',
            ...data
        }  //接口参数
    })
}

// 知识付费内容详情-列表 502
export function getKonwledgeContentList(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_detail_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_detaillist',
            ...data
        }  //接口参数
    })
}

// 知识付费内容详情-新增 503
export function addKonwledgeContent(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_detail_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_detailadd',
            ...data
        }  //接口参数
    })
}

// 知识付费内容详情-修改 504
export function editKonwledgeContent(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_detail_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_detailedit',
            ...data
        }  //接口参数
    })
}

// 知识付费内容详情-修改 505
export function getKonwledgeContentDetail(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_detail_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_detailview',
            ...data
        }  //接口参数
    })
}

// 知识付费内容视频-列表 506
export function getKonwledgeVideoList(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_videourl_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_videourllist',
            ...data
        }  //接口参数
    })
}

// 知识付费内容视频-新增 506
export function addKonwledgeVideo(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_videourl_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_videourladd',
            ...data
        }  //接口参数
    })
}

// 知识付费内容视频-修改 508
export function editKonwledgeVideo(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_videourl_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_videourledit',
            ...data
        }  //接口参数
    })
}

// 知识付费内容视频-详情 509
export function getKonwledgeVideoDetail(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_videourl_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_videourlview',
            ...data
        }  //接口参数
    })
}

// 知识付费购买记录-列表 512
export function getKonwledgeBuyList(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_videourl_buy_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_videourl_buypage',
            ...data
        }  //接口参数
    })
}

// 知识付费观看记录-列表 510
export function getKonwledgeVisitList(data) {
    return request({
        url: "/service/view/ams_Knowledge_pay_videourl_visit_Hand.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { "requestBase": 'VUE_APP_BASE_API_TWO' }, //给接口添加请求头
        params: {
            method: 'ams_Knowledge_pay_videourl_visitpage',
            ...data
        }  //接口参数
    })
}

// 知识付费类型 497
export function getKonwledgeType(data) {
    return request({
        url: '/service/view/ams_Knowledge_pay_type_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_Knowledge_pay_typelist',
            ...data
        }
    })
}

// 知识付费类型-新增 516
export function addKonwledgeType(data) {
    return request({
        url: '/service/view/ams_Knowledge_pay_type_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_Knowledge_pay_typeadd',
            ...data
        }
    })
}

// 知识付费类型-修改 517
export function editKonwledgeType(data) {
    return request({
        url: '/service/view/ams_Knowledge_pay_type_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_Knowledge_pay_typeedit',
            ...data
        }
    })
}

// 知识付费类型-详情 518
export function getKonwledgeTypeDetail(data) {
    return request({
        url: '/service/view/ams_Knowledge_pay_type_Hand.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_Knowledge_pay_typeview',
            ...data
        }
    })
}
